// src/components/TicketCard.js
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";

const CardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
`;

// const DragHandle = styled.div`
//   margin-right: 8px;
//   cursor: grab;
//   user-select: none;
// `;
const DragHandle = styled.div`
  margin-right: 8px;
  cursor: grab;
  user-select: none;
  &:active {
    cursor: grabbing;
  }
`;

const Content = styled.div`
  flex: 1;
  cursor: pointer;
  user-select: none;
`;

export default function TicketCard({ ticket, index, onSelect }) {
  return (
    <Draggable draggableId={ticket.id} index={index}>
      {(provided, snapshot) => (
        <CardContainer
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style,
            boxShadow: snapshot.isDragging
              ? "0 2px 8px rgba(0,0,0,0.2)"
              : "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <DragHandle {...provided.dragHandleProps}>☰</DragHandle>
          <Content onClick={onSelect}>{ticket.ticketName}</Content>
        </CardContainer>
      )}
    </Draggable>
  );
}
